import { saveSecondaryDistrictsAction } from 'actions/adminActions';
import * as types from '../actions';

export default function(state = [], action) {
  let response = action.response;
  let adminList = '';
  let deregister = '';
  let saveSecondaryDistrictsResponse = 'undefined';
  
  switch(action.type) {
    case types.UPDATE_PROFILE_SUCCESS:
      return { ...state, response };
    case types.UPDATE_PROFILE_ERROR:
      return { ...state, response };
    case types.SAVE_SECONDARY_DISTRICTS_SUCCESS:
      saveSecondaryDistrictsResponse = action.response;
      return { ...state, saveSecondaryDistrictsResponse };
    case types.SAVE_SECONDARY_DISTRICTS_ERROR:
      return { ...state, response };
    case types.CHANGE_PASSWORD_SUCCESS:
      return { ...state, response };
    case types.CHANGE_PASSWORD_ERROR:
      return { ...state, response };
    case types.RESET_PASSWORD_SUCCESS:
      return { ...state, response };
    case types.RESET_PASSWORD_ERROR:
      return { ...state, response };
    case types.FORGOT_PASSWORD_SUCCESS:
        return { ...state, response };      
    case types.FORGOT_PASSWORD_ERROR:
      return { ...state, response };
    case types.DEREGISTER_ADMIN_SUCCESS:
      deregister = action.response;
      return { 
        ...state, 
        noServiceResponse: false,
        deregister };
    case types.DEREGISTER_ADMIN_ERROR:
      deregister = action.response;
      return { 
        ...state, 
        noServiceResponse: true,
        deregister };
    case types.FETCH_ALL_ADMIN_SUCCESS:
      adminList = action.response;
      return { 
        ...state, 
        noServiceResponse: false,
        adminList };
    case types.FETCH_ALL_ADMIN_ERROR:
      adminList = action.response;
      return { 
        ...state, 
        noServiceResponse: true,
        adminList };
    default:
      return state;
  }
}